// INQA API helpers — wrap the same endpoints the legacy app talks to under
// /api/inqa/referenz/<slug>/* so the React wizard can read & write the
// referenz_input.json input and the referenz.md output.

export interface InqaReferenzInput {
  meta: {
    referenz_type: "inqa";
    coach_name: string;
    coach_unternehmen: string;
  };
  projekt: {
    titel: string;
    website_url: string;
    unternehmen_name: string;
    kontaktdaten_unternehmen: string;
    branche: string;
    mitarbeitende: string;
    personentage: number | null;
    stunden_pro_tag: number;
    zeitraum_start: string;
    zeitraum_end: string;
  };
  gestaltungsfelder: number[];
  ausgangssituation_stichpunkte: string;
  zielsetzung_stichpunkte: string;
  kerninhalte_stichpunkte: string;
  methoden_stichpunkte: string;
  ergebnisse_stichpunkte: string;
  beteiligte_rollen: string[];
}

export async function saveReferenzInput(
  slug: string,
  data: InqaReferenzInput,
): Promise<void> {
  const r = await fetch("/api/inqa/referenz/" + encodeURIComponent(slug), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    credentials: "include",
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({ error: r.statusText }));
    throw new Error(err.error || r.statusText || "Speichern fehlgeschlagen");
  }
}

export async function fetchReferenzMd(slug: string): Promise<string | null> {
  const r = await fetch("/api/inqa/referenz/" + encodeURIComponent(slug) + "/md", {
    credentials: "include",
  }).catch(() => null);
  if (!r || !r.ok) return null;
  const data = (await r.json()) as { content?: string };
  return data.content ?? "";
}

export async function saveReferenzMd(slug: string, content: string): Promise<void> {
  const r = await fetch("/api/inqa/referenz/" + encodeURIComponent(slug) + "/md", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content }),
    credentials: "include",
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({ error: r.statusText }));
    throw new Error(err.error || r.statusText || "Speichern fehlgeschlagen");
  }
}

export async function downloadReferenzDocx(slug: string): Promise<{ ok: boolean; error?: string }> {
  const r = await fetch("/api/inqa/referenz/" + encodeURIComponent(slug) + "/docx", {
    credentials: "include",
  }).catch(() => null);
  if (!r) return { ok: false, error: "Netzwerkfehler" };
  if (!r.ok) {
    const err = await r.json().catch(() => ({ error: r.statusText }));
    return { ok: false, error: err.error ?? r.statusText };
  }
  const blob = await r.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `referenz_${slug}.docx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return { ok: true };
}
